export default __webpack_public_path__ + "static/media/white-loader.ebbae924.svg";